{
  "v": "5.9.4",
  "fr": 24,
  "ip": 0,
  "op": 81,
  "w": 500,
  "h": 500,
  "nm": "Ziro-Activation_Icon",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Plug Front",
      "parent": 6,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [0, 29.175, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 29.175, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, -0.56],
                    [0, 0],
                    [0.997, 0],
                    [0, 0],
                    [0, 0.56],
                    [0, 0],
                    [-0.56, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0.56],
                    [0, 0],
                    [-0.997, 0],
                    [0, 0],
                    [0, -0.56],
                    [0, 0],
                    [0.56, 0]
                  ],
                  "v": [
                    [1.824, -1.944],
                    [1.829, 1.218],
                    [0.342, 2.755],
                    [-0.308, 2.755],
                    [-1.816, 1.218],
                    [-1.822, -1.944],
                    [-0.994, -2.747],
                    [0.996, -2.747]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.043137254902, 0.145098039216, 0.152941176471, 1],
                "ix": 3,
                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Plug').content('Group 1').content('Stroke 1').color;"
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.667], "y": [1] }, "o": { "x": [1], "y": [0] }, "t": 4, "s": [1.3] },
                  { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 21, "s": [2.5] },
                  { "i": { "x": [0.315], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 77, "s": [2.5] },
                  { "t": 87, "s": [1.3] }
                ],
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-0.028, 29.282], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Rectangle 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Phone",
      "parent": 3,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [236.148, 240.449, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [236.148, 240.449, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.421, 0.421, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, -0.758] },
              "t": 20,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.242] },
              "o": { "x": [0.728, 0.728, 0.333], "y": [0, 0, 0] },
              "t": 22,
              "s": [105, 105, 100]
            },
            { "t": 27, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [12.855, 36.358], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 2, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [236.148, 240.449], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Phone",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Phone Body",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [250.136, 240.391, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [-11.5, 0.55],
                    [-10.7, 1.35],
                    [-11.5, 2.15],
                    [-12.3, 1.35]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [-11.5, -2.95],
                    [-10.7, -2.15],
                    [-11.5, -1.35],
                    [-12.3, -2.15]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [11.6, 0.55],
                    [12.4, 1.35],
                    [11.6, 2.15],
                    [10.8, 1.35]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [11.6, -2.95],
                    [12.4, -2.15],
                    [11.6, -1.35],
                    [10.8, -2.15]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -0.3],
                    [0, 0],
                    [-0.3, 0],
                    [0, 0],
                    [0, 0.3],
                    [0, 0],
                    [0.3, 0]
                  ],
                  "o": [
                    [-0.3, 0],
                    [0, 0],
                    [0, 0.3],
                    [0, 0],
                    [0.3, 0],
                    [0, 0],
                    [0, -0.3],
                    [0, 0]
                  ],
                  "v": [
                    [-7.7, -3.05],
                    [-8.3, -2.45],
                    [-8.3, 2.45],
                    [-7.7, 3.05],
                    [7.7, 3.05],
                    [8.3, 2.45],
                    [8.3, -2.45],
                    [7.7, -3.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1, 0],
                    [0, 0],
                    [0, 1.1],
                    [0, 0],
                    [-1.1, 0],
                    [0, 0],
                    [0, -1.1],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1, 0],
                    [0, 0],
                    [0, -1],
                    [0, 0],
                    [1, 0],
                    [0, 0],
                    [0, 1]
                  ],
                  "v": [
                    [7.7, 4.35],
                    [-7.7, 4.35],
                    [-9.6, 2.45],
                    [-9.6, -2.45],
                    [-7.7, -4.35],
                    [7.7, -4.35],
                    [9.6, -2.45],
                    [9.6, 2.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [257.75, 235.7], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Screen",
          "np": 7,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.2]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.71, 255.7], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.71, 251.8], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0.3]
                      ],
                      "v": [
                        [1, 0.5],
                        [-1, 0.5],
                        [-1.5, 0],
                        [-1, -0.5],
                        [1, -0.5],
                        [1.5, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.7, 248], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.71, 244.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.2]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.81, 255.7], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.81, 251.8], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0.3]
                      ],
                      "v": [
                        [1, 0.5],
                        [-1, 0.5],
                        [-1.5, 0],
                        [-1, -0.5],
                        [1, -0.5],
                        [1.5, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.8, 248], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.81, 244.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 8",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.05, -2.7],
                        [-2.65, -2.7],
                        [-2.65, -5.7],
                        [-6.05, -5.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.35, -2.3],
                        [-6.35, -2.3],
                        [-6.35, -6],
                        [-2.35, -6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.55, -2.7],
                        [1.45, -2.7],
                        [1.45, -5.7],
                        [-1.55, -5.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.85, -2.3],
                        [-1.85, -2.3],
                        [-1.85, -6],
                        [1.85, -6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.65, -2.7],
                        [6.05, -2.7],
                        [6.05, -5.7],
                        [2.65, -5.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.35, -2.3],
                        [2.35, -2.3],
                        [2.35, -6],
                        [6.35, -6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.05, 1.5],
                        [-2.65, 1.5],
                        [-2.65, -1.5],
                        [-6.05, -1.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.35, 1.8],
                        [-6.35, 1.8],
                        [-6.35, -1.9],
                        [-2.35, -1.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.55, 1.5],
                        [1.45, 1.5],
                        [1.45, -1.5],
                        [-1.55, -1.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.85, 1.8],
                        [-1.85, 1.8],
                        [-1.85, -1.9],
                        [1.85, -1.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 10,
                  "ty": "sh",
                  "ix": 11,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.65, 1.5],
                        [6.05, 1.5],
                        [6.05, -1.5],
                        [2.65, -1.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 11",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 11,
                  "ty": "sh",
                  "ix": 12,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.35, 1.8],
                        [2.35, 1.8],
                        [2.35, -1.9],
                        [6.35, -1.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 12",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 12,
                  "ty": "sh",
                  "ix": 13,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.05, 5.7],
                        [-2.65, 5.7],
                        [-2.65, 2.7],
                        [-6.05, 2.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 13",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 13,
                  "ty": "sh",
                  "ix": 14,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.35, 6],
                        [-6.35, 6],
                        [-6.35, 2.3],
                        [-2.35, 2.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 14",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 14,
                  "ty": "sh",
                  "ix": 15,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.55, 5.7],
                        [1.45, 5.7],
                        [1.45, 2.7],
                        [-1.55, 2.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 15",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 15,
                  "ty": "sh",
                  "ix": 16,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.85, 6],
                        [-1.85, 6],
                        [-1.85, 2.3],
                        [1.85, 2.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 16",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 16,
                  "ty": "sh",
                  "ix": 17,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.65, 5.7],
                        [6.05, 5.7],
                        [6.05, 2.7],
                        [2.65, 2.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 17",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 17,
                  "ty": "sh",
                  "ix": 18,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.35, 6],
                        [2.35, 6],
                        [2.35, 2.3],
                        [6.35, 2.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 18",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 18,
                  "ty": "sh",
                  "ix": 19,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, -0.2],
                        [0, 0],
                        [-0.2, 0],
                        [0, 0],
                        [0, 0.2],
                        [0, 0],
                        [0.2, 0],
                        [0, 0]
                      ],
                      "o": [
                        [-0.1, 0],
                        [0, 0],
                        [0, 0.1],
                        [0, 0],
                        [0.1, 0],
                        [0, 0],
                        [0, -0.1],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.65, -6.5],
                        [-6.95, -6.2],
                        [-6.95, 6.4],
                        [-6.65, 6.7],
                        [6.65, 6.7],
                        [6.95, 6.4],
                        [6.95, -6.3],
                        [6.65, -6.6],
                        [-6.65, -6.6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 19",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 19,
                  "ty": "sh",
                  "ix": 20,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [0, 0],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3]
                      ],
                      "v": [
                        [6.65, 6.9],
                        [-6.65, 6.9],
                        [-7.25, 6.3],
                        [-7.25, -6.3],
                        [-6.65, -6.9],
                        [6.65, -6.9],
                        [7.25, -6.3],
                        [7.25, 6.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 20",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 9",
              "np": 21,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.55, 5.9],
                        [2.55, 2.6],
                        [6.25, 2.6],
                        [6.25, 5.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.25, 2.5],
                        [-2.55, 2.5],
                        [-2.55, 5.8],
                        [-6.25, 5.8]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.55, -5.8],
                        [-2.55, -2.5],
                        [-6.25, -2.5],
                        [-6.25, -5.8]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.25, -2.5],
                        [2.55, -2.5],
                        [2.55, -5.8],
                        [6.25, -5.8]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.55, -1.6],
                        [6.25, -1.6],
                        [6.25, 1.7],
                        [2.55, 1.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.65, -2.5],
                        [-1.65, -5.8],
                        [1.65, -5.8],
                        [1.65, -2.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.25, -1.6],
                        [-2.55, -1.6],
                        [-2.55, 1.7],
                        [-6.25, 1.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.65, 2.5],
                        [1.65, 5.8],
                        [-1.65, 5.8],
                        [-1.65, 2.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.65, 1.7],
                        [-1.65, -1.6],
                        [1.65, -1.6],
                        [1.65, 1.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.2, 0],
                        [0, 0],
                        [0, -0.2],
                        [0, 0],
                        [-0.2, 0],
                        [0, 0],
                        [0, 0.2],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-0.2, 0],
                        [0, 0],
                        [0, 0.2],
                        [0, 0],
                        [0.2, 0],
                        [0, 0],
                        [0, -0.2]
                      ],
                      "v": [
                        [6.65, -6.7],
                        [-6.65, -6.7],
                        [-7.05, -6.3],
                        [-7.05, 6.3],
                        [-6.65, 6.7],
                        [6.65, 6.7],
                        [7.05, 6.3],
                        [7.05, -6.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 10",
              "np": 11,
              "cix": 2,
              "bm": 0,
              "ix": 10,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [268.21, 244.7], "ix": 2 },
              "a": { "a": 0, "k": [268.71, 244.2], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Buttons",
          "np": 10,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 3, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "BG",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Buttons",
      "parent": 3,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [253.542, 246.464, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [25.095, 16.96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [20, 20, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 38, "s": [100], "h": 1 },
                  { "t": 41, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [25.22, 16.96], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 0, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [46.709, 16.96], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "2",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 30, "s": [100], "h": 1 },
                  { "t": 33, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.686, 16.96], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "3",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 46, "s": [100], "h": 1 },
                  { "t": 49, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [25.22, 38.531], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "4",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 50, "s": [100], "h": 1 },
                  { "t": 53, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [68.709, 58.531], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "5",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 0, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.686, 38.531], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "6",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 34, "s": [100], "h": 1 },
                  { "t": 37, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [25.22, 59.414], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.956, 93.085], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "7",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 42, "s": [100], "h": 1 },
                  { "t": 45, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [46.709, 59.414], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "8",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 0, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.686, 59.414], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "9",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Phone BG",
      "parent": 3,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [248.55, 243.15, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 3, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "BG",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "Plug",
      "parent": 8,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.501, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 4,
              "s": [0.04, 35.217, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.719, "y": 1 },
              "o": { "x": 0.762, "y": 0 },
              "t": 12,
              "s": [0.04, 36.217, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 21,
              "s": [0.04, 20.267, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.501, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 77,
              "s": [0.04, 20.267, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.315, "y": 1 },
              "o": { "x": 0.762, "y": 0 },
              "t": 82,
              "s": [0.04, 36.217, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            { "t": 87, "s": [0.04, 35.217, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [0, 29.175, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.631, 0.631, 0.333], "y": [0, 0, 0] },
              "t": 4,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 21,
              "s": [60, 60, 100]
            },
            {
              "i": { "x": [0.315, 0.315, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 77,
              "s": [60, 60, 100]
            },
            { "t": 87, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.707, 0],
                    [0, 0],
                    [0, -0.707],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, -0.707],
                    [0, 0],
                    [-0.707, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [4.038, 22.404],
                    [4.038, 28.462],
                    [2.524, 28.462],
                    [2.524, 27.048],
                    [1.312, 25.837],
                    [-1.312, 25.837],
                    [-2.524, 27.048],
                    [-2.524, 28.462],
                    [-4.038, 28.462],
                    [-4.038, 22.404]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.606, 0],
                    [0, 0.505]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0.606],
                    [-0.505, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-1.108, 27.25],
                    [1.01, 27.25],
                    [1.01, 30.279],
                    [-0.101, 31.288],
                    [-1.11, 30.279]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.312, 0.101],
                    [0, 1.312],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 1.413],
                    [1.312, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [5.25, 33.812],
                    [3.029, 37.446],
                    [-3.029, 37.446],
                    [-5.25, 33.812],
                    [-5.25, 29.875],
                    [-2.524, 29.875],
                    [-2.524, 30.38],
                    [0, 32.803],
                    [2.423, 30.38],
                    [2.423, 29.875],
                    [5.149, 29.875],
                    [5.149, 33.812]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-0.404, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.202, 0.404],
                    [0, 0],
                    [0, 0.202],
                    [0, 0],
                    [0.707, 0],
                    [0, 0],
                    [0.707, 0],
                    [0, 0],
                    [0, -0.707],
                    [0, 0],
                    [0, -0.606],
                    [0, 0],
                    [-0.101, -0.202]
                  ],
                  "o": [
                    [0.202, 0.404],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.404, 0],
                    [0, 0],
                    [0.101, -0.202],
                    [0, 0],
                    [0, -0.606],
                    [0, 0],
                    [0, -0.707],
                    [0, 0],
                    [-0.707, 0],
                    [0, 0],
                    [-0.606, 0],
                    [0, 0],
                    [0, 0.202],
                    [0, 0]
                  ],
                  "v": [
                    [-4.24, 38.254],
                    [-3.23, 38.86],
                    [-0.707, 38.86],
                    [0.707, 38.86],
                    [3.23, 38.86],
                    [4.24, 38.254],
                    [6.562, 34.519],
                    [6.764, 33.913],
                    [6.764, 29.673],
                    [5.552, 28.462],
                    [5.552, 22.202],
                    [4.341, 20.991],
                    [-4.341, 20.991],
                    [-5.552, 22.202],
                    [-5.552, 28.462],
                    [-6.764, 29.673],
                    [-6.764, 33.913],
                    [-6.562, 34.519]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.043137254902, 0.145098039216, 0.152941176471, 1],
                "ix": 4,
                "x": "var $bm_rt;\n$bm_rt = content('Group 1').content('Stroke 1').color;"
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.043137254902, 0.145098039216, 0.152941176471, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.667], "y": [1] }, "o": { "x": [1], "y": [0] }, "t": 4, "s": [0] },
                  { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 21, "s": [1.2] },
                  { "i": { "x": [0.315], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 77, "s": [1.2] },
                  { "t": 87, "s": [0] }
                ],
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 6,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "Cable",
      "parent": 6,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [0.153, 38.18, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0.46, 50.5, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [33.333, 33.333, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 19,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-47.52, 121.355],
                          [-47.536, -107.418],
                          [-47.525, -114.211],
                          [-47.518, -120.668],
                          [-47.52, -121.355]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 23,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0.084, 19.571],
                          [0.044, 10.847],
                          [-0.012, 7.592],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-0.034, -7.912],
                          [-0.049, -12.028],
                          [0.037, -23.383],
                          [0, 0]
                        ],
                        "v": [
                          [-47.52, 121.355],
                          [-47.564, -38.427],
                          [-56.931, -62.328],
                          [-47.621, -83.55],
                          [-47.52, -121.355]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 29,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0.026, 6.092],
                          [-3.237, 15.444],
                          [-0.755, 21.21],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-0.011, -2.462],
                          [2.78, -13.261],
                          [0.259, -7.273],
                          [0, 0]
                        ],
                        "v": [
                          [-47.52, 121.355],
                          [-47.575, 21.372],
                          [-68.26, 0.155],
                          [-47.6, -27.315],
                          [-47.52, -121.355]
                        ],
                        "c": false
                      }
                    ]
                  },
                  {
                    "t": 34,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0.484, 18.003],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [-0.484, -17.998],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [-47.52, 121.355],
                          [-47.58, 48.395],
                          [-73.379, 28.391],
                          [-47.518, 9.895],
                          [-47.52, -121.355]
                        ],
                        "c": false
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "rd",
              "nm": "Round Corners 1",
              "r": { "a": 0, "k": 10, "ix": 1 },
              "ix": 2,
              "mn": "ADBE Vector Filter - RC",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.043137254902, 0.145098039216, 0.152941176471, 1],
                "ix": 3,
                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Plug').content('Group 1').content('Stroke 1').color;"
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.667], "y": [1] }, "o": { "x": [1], "y": [0] }, "t": 4, "s": [5] },
                  { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 21, "s": [8] },
                  { "i": { "x": [0.17], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 77, "s": [8] },
                  { "t": 87, "s": [5] }
                ],
                "ix": 5
              },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [47.98, 171.855], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Rectangle 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 4,
      "nm": "BG",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [249.8, 251.4, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-27.415, 0],
                    [0, -27.415],
                    [27.415, 0],
                    [0, 27.415]
                  ],
                  "o": [
                    [27.415, 0],
                    [0, 27.415],
                    [-27.415, 0],
                    [0, -27.415]
                  ],
                  "v": [
                    [0, -49.64],
                    [49.64, 0],
                    [0, 49.64],
                    [-49.64, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.839215695858, 0.937254905701, 0.952941179276, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 81,
      "st": 0,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": []
}
